import { Preferences } from "@capacitor/preferences";

export interface MonsterCountData {
  [monsterId: string]: number;
}

const STORAGE_KEY = "monspot-monster-count-v1";

export class MonsterCountManager {
  private counts: MonsterCountData = {};

  // 앱 시작 시 또는 씬 진입 전에 초기화 메서드 호출 필요
  async init(): Promise<void> {
    await this.load();
  }

  //  Preferences에서 데이터 불러오기
  private async load(): Promise<void> {
    try {
      const { value } = await Preferences.get({ key: STORAGE_KEY });

      if (!value) {
        this.counts = {};
        return;
      }

      const parsed = JSON.parse(value);

      if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
        this.counts = {};
        return;
      }

      this.counts = parsed;
    } catch (error) {
      console.error("[MonsterCountManager] load 실패", error);
      this.counts = {};
    }
  }

  // Preferences에 데이터 저장
  private async save(): Promise<void> {
    try {
      await Preferences.set({
        key: STORAGE_KEY,
        value: JSON.stringify(this.counts),
      });
    } catch (error) {
      console.error("[MonsterCountManager] save 실패", error);
    }
  }

  // 특정 몬스터 분류된 횟수 증가
  async increment(monsterId: string, amount = 1): Promise<number> {
    if (!monsterId) {
      throw new Error("monsterId는 비어 있을 수 없습니다.");
    }

    const current = this.counts[monsterId] ?? 0;
    const next = current + amount;

    this.counts[monsterId] = next;
    await this.save();

    return next;
  }

  // 특정 몬스터 분류된 횟수 조회
  getCount(monsterId: string): number {
    return this.counts[monsterId] ?? 0;
  }
}

export const monsterCountManager = new MonsterCountManager();
